<script setup lang="ts">
defineProps<{
  show: boolean;
  x: number;
  y: number;
}>();
</script>

<template>
  <div v-if="show" class="hand-cursor-simulation" :style="{ top: y + '%', left: x + '%' }">
    <div class="hand-dot"></div>
  </div>
</template>

<style scoped>
.hand-cursor-simulation { 
  position: absolute; 
  width: 24px; 
  height: 24px; 
  background: rgba(226, 27, 13, 0.4); 
  border: 2px solid #e21b0d;
  border-radius: 50%; 
  z-index: 200; 
  pointer-events: none;
  transform: translate(-50%, -50%);
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.hand-dot {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: #e21b0d;
  border-radius: 50%;
}
</style>
